'use strict';

frontendApp.factory('ThemeService', ['$rootScope', '$log', '$window', 'ConfigService', 'HttpService', function ($rootScope, $log, $window, ConfigService, HttpService) {

  var defaultTheme = {
    'name': 'Indexed I/O - Big Data eDiscovery',
    'largeLogo': 'https://s3.amazonaws.com/iio-assets/theme/default/iio_logo_large.png',
    'headerLogo': 'https://s3.amazonaws.com/iio-assets/theme/default/iio_logo_header.png',
    'footerLogo': '',
    'backgroundColor': '#ffffff',
    'textColor': '#000000',
    'navBackgroundColor': '#000000',
    'navTextColor': '#ffffff',
    'linkColor': '#0088cc',
    'messageType': null,
    'message': null
  };

  var stagingTheme = {
    ...defaultTheme,
    'name': 'Staging - Indexed I/O - Big Data eDiscovery',
    'navBackgroundColor': '#430063',
  };

    var singaporeTheme = {
    ...defaultTheme,
    'name': 'Singapore - Indexed I/O - Big Data eDiscovery',
    'navBackgroundColor': '#002b63',
  };

    var greenDeployTheme = {
    ...defaultTheme,
    'name': 'Green - Indexed I/O - Big Data eDiscovery',
    'navBackgroundColor': '#006315',
  };

  var _service = {
    theme: {}
  };

  var hasTheme = function () {
    return !_.isEmpty(_service.theme);
  };

  _service.EVENTS = {
    THEME_CHANGED: 'ThemeService:THEME_CHANGED'
  };

  _service.setCurrentTheme = function (theme) {
    $log.log("Setting theme", theme);
    _service.theme = theme;
    $rootScope.$broadcast(_service.EVENTS.THEME_CHANGED, theme);
  };

  _service.getCurrentTheme = function (callback) {
    return _service.theme;
    // var deferred = $q.defer();
    // var promise = deferred.promise;
    // var theme;

    // promise.then(function(theme) {
    //     if (callback) callback(theme);
    // });

    // if (hasTheme()) {
    //     deferred.resolve(_service.theme);
    // } else {
    //     _service.findThemeForSubdomain(function(theme) {
    //         deferred.resolve(theme);
    //     });
    // }

    // return promise;
  };

  _service.findThemeForSubdomain = function (callback) {
    var hostName = $window.location.hostname;
    var hostParts = hostName.split(".");
    var subdomain = hostParts.shift();

    console.log('Subdomain: ' + subdomain);

    const defaultThemeSubdomains = ['app'];

    const stagingThemeSubdomains = ['app-staging', 'localhost'];

    const singaporeThemeSubdomains = ['app-sg'];

    const greenDeployThemeSubdomains = ['app-temp'];

    if (defaultThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(defaultTheme);
      if (callback) callback(defaultTheme);
    } else if (stagingThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(stagingTheme);
      if (callback) callback(stagingTheme);
    } else if (singaporeThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(singaporeTheme);
      if (callback) callback(singaporeTheme);
    } else if (greenDeployThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(greenDeployTheme);
      if (callback) callback(greenDeployTheme);
    } else {
      HttpService.$http({
        method: 'GET',
        url: ConfigService.getServerBaseUrl() + '/organization/theme/' + subdomain
      }).success(function (response, status) {
        if (response.name == null) {
          _service.setCurrentTheme(defaultTheme);
          if (callback) callback(defaultTheme);
        } else {
          _service.setCurrentTheme(response);
          if (callback) callback(response);
        }
      }).error(function (data, status) {
        _service.setCurrentTheme(defaultTheme);
        if (callback) callback();
        $log.error("Unable to fetch theme");
      });
    }
  };

  return _service;
}]);

